import { FtthState } from '@features/siteStatusV2/constants';

const MapStateToKey: Record<FtthState, string> = {
  NO_STATE: 'orderDetails.generalInformations.state.noState',
  CANCELLED_OR_TERMINATED: 'orderDetails.generalInformations.state.cancelledOrTerminated',
  REJECTED_CHECK_OC: 'orderDetails.generalInformations.state.rejectedCheckOc',
  IN_SERVICE: 'orderDetails.generalInformations.state.inService',
  COMMISSIONING_IN_PROGRESS: 'orderDetails.generalInformations.state.commissioningInProgress',
  RECEIVED_BUT_REJECTED: 'orderDetails.generalInformations.state.receivedButRejected',
  AWAITING_OI_RESOLUTION: 'orderDetails.generalInformations.state.awaitingOiResolution',
  ORDER_NOT_COMPLETED: 'orderDetails.generalInformations.state.orderNotCompleted',
  ORDER_BEING_CLOSED: 'orderDetails.generalInformations.state.orderBeingClosed',
  TERMINATED_FOLLOWING_NEW_ORDER:
    'orderDetails.generalInformations.state.terminatedFollowingNewOrder',
  TERMINATED_BY_OC: 'orderDetails.generalInformations.state.terminatedByOc',
  WAINTING_CONNECTION_BY_OC: 'orderDetails.generalInformations.state.waintingConnectionByOc',
  OPTICAL_ROUTE_BUILD: 'orderDetails.generalInformations.state.opticalRouteBuild',
  BLOCKING_RESOLVED_BY_AXIONE: 'orderDetails.generalInformations.state.blockingResolvedByAxione',
  WORK_ORDER_GENERATED: 'orderDetails.generalInformations.state.workOrderGenerated',
  WAINTING_OC_INTERVENTION: 'orderDetails.generalInformations.state.waintingOcIntervention',
  ORDER_IN_PROGRESS: 'orderDetails.generalInformations.state.orderInProgress'
};

export default MapStateToKey;
